var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 500,
    viewBox: "0 0 750 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.941 278.103C710.941 278.103 720.905 100.74 570.446 51.9162C419.986 3.09117 344.258 38.9622 296.43 84.7982C248.602 130.633 232.659 160.526 177.856 166.504C123.053 172.483 72.2358 182.447 46.3288 249.207C20.4218 315.967 53.3038 368.777 103.125 401.659C152.946 434.541 210.738 399.666 256.574 420.591C302.409 441.516 331.306 476.39 424.969 480.376C518.632 484.362 521.622 457.458 569.45 415.609C617.277 373.759 701.973 417.602 710.941 278.103Z",
    fill: "#3DE96E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M710.941 278.103C710.941 278.103 720.905 100.74 570.446 51.9162C419.986 3.09117 344.258 38.9622 296.43 84.7982C248.602 130.633 232.659 160.526 177.856 166.504C123.053 172.483 72.2358 182.447 46.3288 249.207C20.4218 315.967 53.3038 368.777 103.125 401.659C152.946 434.541 210.738 399.666 256.574 420.591C302.409 441.516 331.306 476.39 424.969 480.376C518.632 484.362 521.622 457.458 569.45 415.609C617.277 373.759 701.973 417.602 710.941 278.103Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.718 52.352C344.504 51.691 344.281 51.026 344.042 50.36C335.204 25.784 294.09 24.089 294.089 54.293C294.089 60.11 280.128 54.293 274.892 61.855C269.656 69.417 275.474 74.071 268.493 76.398C261.512 78.725 260.931 72.908 252.205 73.489C243.479 74.071 244.643 82.215 241.734 84.542C238.825 86.869 238.825 85.705 232.426 86.287C226.027 86.869 224.864 91.522 224.864 91.522H377.856C377.856 91.522 383.673 74.071 373.202 67.672C362.731 61.273 362.731 69.999 354.587 66.508C347.86 63.626 346.6 58.153 344.718 52.352Z",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.009 85.1588C350.009 85.1588 353.178 75.3628 345.399 68.1598C337.62 60.9568 329.553 64.9908 327.248 68.1598C324.943 71.3288 324.943 77.3798 321.198 77.9558C317.453 78.5318 318.317 71.6178 310.25 73.3458C302.183 75.0748 305.352 83.1418 301.607 84.8698C297.862 86.5988 297.862 80.2598 292.676 82.2768C287.49 84.2938 287.778 88.0388 287.778 88.0388",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.628 65.586C308.628 65.586 302.213 60.453 293.872 64.303C285.532 68.152 289.381 76.172 285.532 78.097C281.683 80.022 279.758 77.776 274.946 80.022C270.134 82.267 270.455 85.475 270.455 85.475",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M584.178 109.517C584.047 109.114 583.912 108.709 583.766 108.303C578.381 93.328 553.329 92.296 553.328 110.699C553.328 114.244 544.821 110.699 541.631 115.307C538.441 119.915 541.985 122.75 537.732 124.168C533.479 125.586 533.124 122.041 527.807 122.396C522.49 122.75 523.199 127.713 521.427 129.13C519.655 130.548 519.655 129.839 515.756 130.193C511.857 130.547 511.148 133.383 511.148 133.383H604.369C604.369 133.383 607.913 122.75 601.533 118.851C595.153 114.952 595.153 120.269 590.19 118.142C586.092 116.386 585.324 113.051 584.178 109.517Z",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M587.401 129.506C587.401 129.506 589.332 123.537 584.592 119.148C579.852 114.759 574.937 117.217 573.532 119.148C572.128 121.079 572.128 124.766 569.845 125.117C567.563 125.468 568.09 121.255 563.174 122.308C558.259 123.361 560.19 128.277 557.907 129.33C555.625 130.383 555.625 126.521 552.465 127.75C549.305 128.979 549.481 131.261 549.481 131.261",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M562.187 117.58C562.187 117.58 558.278 114.453 553.196 116.798C548.114 119.143 550.46 124.03 548.114 125.203C545.768 126.376 544.596 125.008 541.664 126.376C538.732 127.744 538.928 129.699 538.928 129.699",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.703 116.259C260.572 115.856 260.437 115.451 260.291 115.045C254.906 100.071 229.854 99.0382 229.854 117.442C229.854 120.987 221.347 117.442 218.157 122.05C214.967 126.658 218.511 129.494 214.258 130.911C210.005 132.328 209.65 128.784 204.333 129.139C199.016 129.493 199.725 134.456 197.953 135.873C196.181 137.291 196.181 136.582 192.282 136.936C188.383 137.29 187.674 140.126 187.674 140.126H280.895C280.895 140.126 284.439 129.493 278.059 125.594C271.679 121.695 271.679 127.012 266.716 124.885C262.617 123.128 261.849 119.793 260.703 116.259Z",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.926 136.249C263.926 136.249 265.857 130.28 261.117 125.891C256.377 121.502 251.462 123.96 250.057 125.891C248.653 127.822 248.653 131.509 246.37 131.86C244.088 132.211 244.614 127.998 239.699 129.051C234.783 130.104 236.715 135.02 234.432 136.073C232.15 137.126 232.15 133.264 228.99 134.493C225.83 135.722 226.006 138.004 226.006 138.004",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.712 124.322C238.712 124.322 234.803 121.195 229.721 123.54C224.639 125.885 226.985 130.772 224.639 131.945C222.293 133.118 221.121 131.749 218.189 133.118C215.257 134.486 215.453 136.441 215.453 136.441",
    stroke: "#B2B2B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M537.431 153.255C537.431 194.551 509.048 210.473 474.036 210.473C439.024 210.473 410.641 194.551 410.641 153.255C410.641 111.959 439.024 19.314 474.036 19.314C509.048 19.314 537.431 111.959 537.431 153.255Z",
    fill: "#3DE96E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M537.431 153.255C537.431 194.551 509.048 210.473 474.036 210.473C439.024 210.473 410.641 194.551 410.641 153.255C410.641 111.959 439.024 19.314 474.036 19.314C509.048 19.314 537.431 111.959 537.431 153.255Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M448.501 163.046L467.493 171.745L466.14 246.193H475.823L475.014 188.176L499.92 174.645L512.589 180.927L503.762 173.195L516.658 164.013L484.044 178.994L488.716 169.329L479.227 179.961L475.369 180.444L474.726 170.779L510.732 127.285L493.124 143.716L495.171 121.485L504.903 96.3551L494.141 117.619L493.732 92.9731L489.757 144.682L482.193 154.831L481.01 141.783L476.925 157.731L473.655 164.496L475.68 111.82L486.934 91.0391L475.052 103.121L472.71 78.4751L470.549 122.935L446.347 91.5231L469.171 127.285L468.977 144.682L452.401 135.984L453.618 121.969L449.469 134.05L432.886 124.868L468.59 150.482L467.88 165.946L424.137 150.965L445.094 161.597L422.041 170.296L448.501 163.046Z",
    fill: "#B2B2B2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M237.797 153.255C237.797 194.551 209.414 210.473 174.402 210.473C139.39 210.473 111.007 194.551 111.007 153.255C111.007 111.959 139.39 19.314 174.402 19.314C209.414 19.314 237.797 111.959 237.797 153.255Z",
    fill: "#3DE96E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M237.797 153.255C237.797 194.551 209.414 210.473 174.402 210.473C139.39 210.473 111.007 194.551 111.007 153.255C111.007 111.959 139.39 19.314 174.402 19.314C209.414 19.314 237.797 111.959 237.797 153.255Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.867 163.046L167.859 171.745L166.506 246.193H176.19L175.381 188.176L200.286 174.645L212.955 180.927L204.128 173.195L217.024 164.013L184.41 178.994L189.083 169.329L179.594 179.961L175.736 180.444L175.092 170.779L211.098 127.285L193.49 143.716L195.538 121.485L205.269 96.3551L194.507 117.619L194.098 92.9731L190.123 144.682L182.559 154.831L181.376 141.783L177.292 157.731L174.021 164.496L176.046 111.82L187.3 91.0391L175.419 103.121L173.077 78.4751L170.915 122.935L146.713 91.5231L169.537 127.285L169.343 144.682L152.767 135.984L153.984 121.969L149.836 134.05L133.252 124.868L168.956 150.482L168.246 165.946L124.503 150.965L145.46 161.597L122.408 170.296L148.867 163.046Z",
    fill: "#B2B2B2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M671.876 327.497H690.624",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M308.84 327.497H663.354",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.415 327.497H300.318",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.018 405.665H690.624",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.415 405.665H98.348",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.027 245.897H690.624",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.415 245.897H120.505",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M512.819 304.698C512.819 304.698 515.634 344.715 516.036 350.346C516.438 355.977 513.623 376.689 514.829 388.151C516.036 399.613 519.856 417.51 519.856 417.51C519.856 417.51 524.079 423.141 527.497 420.325C530.916 417.51 529.91 412.482 529.91 408.26C529.91 404.037 533.932 368.243 534.937 361.205C535.942 354.167 536.546 352.357 536.546 352.357L544.389 310.329C544.389 310.329 554.364 362.925 557.38 370.165C560.396 377.404 574.553 410.473 574.553 410.473L578.776 419.12L585.211 417.109C585.211 417.109 582.919 373.182 580.707 367.149C578.495 361.116 577.49 358.1 577.49 358.1L578.173 314.15L578.776 305.704L514.025 301.883L512.819 304.698Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M580.708 367.147C578.496 361.114 577.491 358.098 577.491 358.098L578.174 314.148L578.777 305.702L514.025 301.881L512.819 304.696C512.819 304.696 515.634 344.713 516.036 350.344C516.438 355.975 513.623 376.687 514.829 388.149C515.238 392.03 515.946 396.648 516.704 401.06C519.608 402.036 524.153 402.873 530.371 402.057C531.455 390.378 534.142 366.777 534.938 361.203C535.943 354.165 536.547 352.355 536.547 352.355L544.39 310.327C544.39 310.327 554.365 362.924 557.381 370.163C559.539 375.342 566.451 392.989 571.957 403.25C575.915 403.627 580.519 404.005 584.135 401.611C582.068 388.148 582.043 370.787 580.708 367.147Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M584.81 410.07C584.81 410.07 581.19 409.064 579.179 410.673C577.168 412.282 577.57 415.298 577.57 415.298L575.76 412.282C575.76 412.282 574.553 411.478 575.157 414.695C575.76 417.912 576.363 420.929 576.363 420.929C576.363 420.929 575.358 422.538 576.765 425.353C578.172 428.168 579.781 428.369 581.189 431.587C582.597 434.804 582.798 439.832 588.227 441.843C593.657 443.854 600.647 444.633 600.245 435.182C599.843 425.731 591.445 421.533 590.037 418.516C588.631 415.499 584.81 410.07 584.81 410.07Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M588.228 441.842C593.657 443.853 600.648 444.632 600.246 435.181C600.21 434.346 600.094 433.566 599.944 432.81C599.314 438.289 597.426 442.229 590.464 440.813C581.719 439.034 583.201 430.438 580.237 425.843C577.273 421.248 576.365 420.928 576.365 420.928C576.365 420.928 575.36 422.537 576.767 425.352C578.175 428.167 579.783 428.368 581.191 431.586C582.597 434.804 582.798 439.831 588.228 441.842Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M526.494 416.303C526.494 416.303 522.472 410.874 520.461 410.874C518.45 410.874 517.445 412.282 517.244 414.695C517.043 417.108 514.429 422.538 514.429 422.538C514.429 422.538 501.961 432.794 501.157 434.402C500.353 436.011 504.173 437.016 506.989 437.418C509.804 437.82 532.126 437.418 532.126 437.418C532.126 437.418 533.333 436.01 533.131 432.793C532.93 429.576 533.131 420.124 532.528 417.51C531.923 414.896 529.309 415.7 526.494 416.303Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M511.166 435.329C505.825 435.329 503.168 434.315 501.888 433.503C501.511 433.9 501.25 434.212 501.156 434.401C500.352 436.01 504.172 437.015 506.988 437.417C509.803 437.819 532.125 437.417 532.125 437.417C532.125 437.417 533.221 436.104 533.135 433.162C532.514 433.327 531.862 433.505 531.176 433.698C525.395 435.329 520.059 435.329 511.166 435.329Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M512.015 295.246L512.417 306.909C512.417 306.909 522.673 314.349 544.19 316.964C565.707 319.579 579.381 315.556 579.381 315.556C579.381 315.556 583.202 302.083 583.805 279.963C584.408 257.843 577.37 210.988 577.37 210.988L532.929 211.792L512.015 295.246Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M523.962 292.688L523.027 301.728C523.027 301.728 508.688 297.364 505.415 295.805C502.142 294.246 501.518 293.155 501.518 293.155L503.232 284.894C503.232 284.894 511.805 292.533 523.962 292.688Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M536.551 204.144C536.551 204.144 533.238 200.389 520.205 204.586C507.173 208.783 494.141 214.526 485.305 218.502C476.47 222.478 475.144 227.117 479.341 232.197C483.538 237.277 486.409 237.94 492.594 237.498C498.779 237.056 504.743 232.639 510.707 231.313C516.671 229.988 518.659 229.546 518.659 229.546C518.659 229.546 500.767 274.828 499.884 280.35C499 285.872 503.86 288.302 510.707 291.173C517.554 294.044 523.96 293.824 523.96 293.824L541.189 215.189C541.189 215.189 543.177 210.992 536.551 204.144Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M575.203 187.865C575.203 187.865 579.741 186.288 583.235 188.035C586.729 189.782 588.04 197.062 588.04 197.062C588.04 197.062 591.534 194.296 595.174 196.48C598.814 198.664 599.979 200.993 599.979 200.993C599.979 200.993 601.872 198.518 605.512 199.537C609.152 200.556 610.462 202.886 611.045 204.196C611.627 205.506 610.171 204.924 605.076 204.924C599.98 204.924 599.543 203.031 599.543 203.031C599.543 203.031 597.213 204.05 591.827 203.759C586.44 203.468 586.149 202.157 586.149 202.157C586.149 202.157 587.896 203.759 580.18 204.195C572.464 204.632 557.322 202.157 558.778 192.693C560.234 183.229 566.058 181.337 569.406 182.065C572.753 182.794 575.203 187.865 575.203 187.865Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M552.435 297.056L553.038 305.904C553.038 305.904 558.668 308.317 568.522 306.507C578.376 304.697 588.229 300.273 590.642 296.654C593.055 293.034 593.055 289.012 593.055 289.012C593.055 289.012 573.951 296.251 564.701 297.257C555.451 298.263 552.435 297.056 552.435 297.056Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M559.187 221.148C559.187 221.148 552.017 284.584 551.861 290.974C551.705 297.364 552.329 299.546 552.329 299.546C552.329 299.546 566.98 302.507 581.319 296.429C595.658 290.35 595.97 287.233 595.502 283.96C595.034 280.687 587.709 240.163 587.553 237.669C587.397 235.175 587.397 231.123 587.397 231.123L588.644 229.876C588.644 229.876 603.607 239.695 613.894 239.851C624.181 240.007 627.298 233.772 625.584 224.576C623.87 215.38 609.374 211.64 595.814 206.496C582.254 201.353 577.578 200.106 567.603 200.106C557.628 200.106 559.187 221.148 559.187 221.148Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M537.373 197.063C537.373 197.063 531.841 197.791 531.404 199.101C530.967 200.411 530.094 205.507 529.657 207.982C529.22 210.457 529.075 223.415 547.128 223.997C565.181 224.579 574.208 217.737 575.373 208.71C576.538 199.683 576.392 201.43 573.771 197.063C571.15 192.695 565.181 192.986 562.706 193.278C560.231 193.569 556.3 198.81 548.292 199.393C540.285 199.975 537.373 197.063 537.373 197.063Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M543.052 205.07C543.052 205.07 546.691 209.815 549.192 209.503C549.192 209.503 552.953 211.913 559.941 204.197C566.93 196.48 561.543 196.189 561.543 196.189C561.543 196.189 552.078 206.089 543.052 205.07Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M576.101 201.722C576.101 201.722 577.702 210.312 565.327 217.009C552.952 223.706 547.273 221.814 547.273 221.814",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M556.446 208.273C554.262 210.02 548.73 211.476 542.178 211.039C535.626 210.602 532.278 203.905 532.278 203.905",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M573.772 199.247C573.772 199.247 570.86 206.09 557.757 212.642",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M488.982 237.553C488.982 237.553 485.603 235.526 489.175 230.313C492.747 225.1 497.766 226.162 498.635 229.155C499.504 232.147 498.731 235.816 495.739 236.877C492.747 237.939 490.141 238.229 488.982 237.553Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M512.501 223.464C512.501 223.464 517.944 222.92 518.488 222.811C519.032 222.702 520.665 223.355 519.25 224.879C517.835 226.403 517.508 226.621 512.828 227.274C508.147 227.927 510.542 229.56 506.732 231.846C502.922 234.132 502.269 234.132 502.269 234.132C502.269 234.132 503.793 225.315 506.841 222.812C509.888 220.308 512.501 223.464 512.501 223.464Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M496.752 227.341C496.752 227.341 500.986 221.114 503.975 219.121C506.964 217.128 514.935 215.136 516.927 216.381C518.92 217.626 517.176 218.872 517.176 218.872C517.176 218.872 518.92 220.615 517.425 221.612C515.93 222.608 508.956 225.597 508.956 225.597C508.956 225.597 515.183 225.348 515.93 226.593C516.677 227.838 516.309 228.58 515.003 228.58C513.697 228.58 510.758 228.362 509.234 228.362C507.71 228.362 505.424 229.124 505.424 229.124C505.424 229.124 507.601 229.559 511.411 230.321C511.411 230.321 512.826 231.083 511.193 232.28C509.56 233.477 505.424 231.409 504.989 231.409C504.554 231.409 504.009 234.674 499.982 236.307C495.955 237.94 492.798 236.96 493.233 233.15C493.67 229.342 496.752 227.341 496.752 227.341Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M517.177 218.872C517.177 218.872 513.916 219.437 510.977 220.199C508.038 220.961 505.535 223.029 505.208 223.138",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M517.177 218.872C517.177 218.872 513.916 219.437 510.977 220.199C508.038 220.961 505.535 223.029 505.208 223.138",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M508.957 225.597C508.957 225.597 507.276 225.424 505.861 225.859C504.446 226.294 503.466 226.621 503.466 226.621",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M508.957 225.597C508.957 225.597 507.276 225.424 505.861 225.859C504.446 226.294 503.466 226.621 503.466 226.621",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M489.465 219.213C489.465 219.213 495.16 218.248 499.6 224.136",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M600.677 226.074C600.677 226.074 605.144 219.878 616.673 218.725",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M609.612 231.838C609.612 235.499 606.741 238.467 603.199 238.467C599.657 238.467 596.786 235.499 596.786 231.838C596.786 228.177 599.657 225.209 603.199 225.209C606.741 225.209 609.612 228.177 609.612 231.838Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M590.314 221.523C590.314 221.523 587.353 217.822 584.763 218.562C582.172 219.302 577.731 223.928 578.472 224.853C579.212 225.778 579.582 226.148 581.803 224.853C584.024 223.558 585.319 222.447 586.059 222.818C586.799 223.188 587.724 225.039 587.724 226.334C587.724 227.629 587.354 229.295 585.688 229.85C584.023 230.405 580.692 230.59 576.991 230.405C573.29 230.22 574.4 233.921 579.211 234.291C584.022 234.661 589.388 233.736 589.388 233.736C589.388 233.736 592.164 234.846 594.014 234.846C595.864 234.846 595.864 234.846 595.864 234.846C595.864 234.846 598.455 237.252 601.785 237.252C605.115 237.252 606.596 233.366 605.116 229.665C603.636 225.964 595.309 223.004 594.199 222.633C593.089 222.262 590.314 221.523 590.314 221.523Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M595.125 224.297L590.314 221.521C590.314 221.521 582.172 226.147 583.282 228.182C584.392 230.218 585.502 228.922 587.908 227.627C590.314 226.332 591.239 225.962 591.239 225.962C591.239 225.962 595.31 227.258 595.125 224.297Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M599.808 225.562L594.997 222.786C594.997 222.786 586.855 227.412 587.965 229.447C589.075 231.483 590.185 230.187 592.591 228.892C594.997 227.597 595.922 227.227 595.922 227.227C595.922 227.227 599.993 228.523 599.808 225.562Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M602.207 227.794L598.023 225.38C598.023 225.38 589.881 230.006 590.991 232.041C592.101 234.076 593.212 232.781 595.617 231.486C598.023 230.191 598.948 229.821 598.948 229.821C598.948 229.821 599.966 230.145 600.96 230.099",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M602.207 227.794L598.023 225.38C598.023 225.38 589.881 230.006 590.991 232.041C592.101 234.076 593.212 232.781 595.617 231.486C598.023 230.191 598.948 229.821 598.948 229.821C598.948 229.821 599.966 230.145 600.96 230.099",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M565.541 156.428C571.543 156.428 576.409 152.038 576.409 146.624C576.409 141.209 571.543 136.82 565.541 136.82C559.539 136.82 554.673 141.209 554.673 146.624C554.673 152.038 559.539 156.428 565.541 156.428Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M531.476 177.741C531.476 177.741 531.476 187.003 532.338 191.742C533.2 196.481 540.954 205.959 545.909 206.82C550.863 207.682 556.679 204.881 561.203 200.573C565.726 196.265 568.958 185.495 569.173 184.848C569.388 184.202 567.234 178.386 560.126 175.155C545.827 168.655 539.878 170.632 535.785 172.57C531.691 174.51 531.476 177.741 531.476 177.741Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M545.693 183.773C545.693 183.773 546.339 185.281 544.831 185.927C543.323 186.573 542.246 188.727 544.185 189.804C546.124 190.881 547.201 189.589 547.201 189.589",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M543.753 193.681C543.753 193.681 548.492 196.266 553.446 192.173",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M556.247 182.157C556.247 183.287 555.716 184.203 555.062 184.203C554.408 184.203 553.877 183.287 553.877 182.157C553.877 181.027 554.407 180.111 555.062 180.111C555.717 180.111 556.247 181.027 556.247 182.157Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M541.814 181.403C541.814 182.533 541.284 183.449 540.629 183.449C539.974 183.449 539.444 182.533 539.444 181.403C539.444 180.273 539.975 179.357 540.629 179.357C541.283 179.357 541.814 180.273 541.814 181.403Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M530.458 162.689C530.458 162.689 534.238 155.011 541.916 150.64C549.594 146.269 561.407 147.805 565.423 151.703C569.439 155.601 572.747 161.153 573.219 166.232C573.692 171.311 575.581 165.051 555.973 163.869C536.364 162.688 530.34 164.105 530.34 164.105L530.458 162.689Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M530.781 179.962C530.781 179.962 531.691 175.587 546.338 175.802C560.986 176.017 568.578 186.53 568.794 187.607C569.009 188.684 573.695 191.311 575.203 187.865C576.711 184.418 578.865 176.448 578.219 171.925C577.573 167.402 573.049 160.724 551.509 158.354C529.968 155.984 525.445 165.462 525.445 168.478C525.445 171.494 525.876 176.448 526.737 178.817C527.599 181.188 530.781 179.962 530.781 179.962Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M530.458 162.689C530.458 162.689 531.55 172.166 531.987 173.622",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M537.519 160.664C537.519 161.683 538.829 170.855 538.829 170.855",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M545.527 159.645V164.304",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M563.435 162.266L560.668 171.438",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M576.101 172.894L573.481 179.446",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M545.86 181.049C545.86 177.183 542.726 174.048 538.859 174.048C534.992 174.048 531.858 177.182 531.858 181.049C531.858 184.915 534.992 188.05 538.859 188.05C542.726 188.05 545.86 184.915 545.86 181.049Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M561.334 181.049C561.334 177.183 558.2 174.048 554.333 174.048C550.466 174.048 547.332 177.182 547.332 181.049C547.332 184.915 550.466 188.05 554.333 188.05C558.2 188.05 561.334 184.915 561.334 181.049Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M545.932 179.817H547.35",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M590.465 254.507L591.43 259.42C627.43 263.397 654.261 276.379 654.261 291.171C654.261 309.017 614.669 324.093 567.804 324.093C520.939 324.093 481.347 309.017 481.347 291.171C481.347 282.912 489.831 275.248 503.587 269.395L505.611 263.02C487.454 269.927 476.228 279.904 476.228 291.171C476.228 312.503 516.453 329.212 567.804 329.212C619.155 329.212 659.38 312.503 659.38 291.171C659.38 273.042 630.71 258.539 590.465 254.507Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M426.166 242.905L429.621 238.298L436.762 241.523L434.689 247.512L426.166 242.905Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M338.631 297.5C338.631 297.5 335.176 299.343 334.945 310.861C334.715 322.379 339.322 325.604 341.395 326.064C342.925 326.404 371.792 326.242 386.823 326.134C394.77 326.077 401.308 319.384 400.645 311.465C400.57 310.572 400.407 309.676 400.136 308.787C397.602 300.494 396.312 298.49 396.312 298.49L338.631 297.5Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M359.132 224.938C359.132 224.938 351.069 226.781 342.316 230.697C333.562 234.613 324.809 263.868 326.882 272.161C328.955 280.454 331.95 281.145 334.484 280.223C337.018 279.302 339.782 275.846 339.782 275.846C339.782 275.846 333.793 298.191 335.175 301.876C336.557 305.562 342.086 306.253 350.609 306.022C359.132 305.792 390.691 306.022 390.691 306.022C390.691 306.022 399.444 306.022 400.596 299.802C401.748 293.582 396.91 275.384 396.91 275.384C396.91 275.384 405.663 283.216 413.035 281.834C420.406 280.452 429.993 263.412 432.385 258.799C435.61 252.579 435.149 250.046 434.689 247.512C434.228 244.978 428.239 241.062 424.553 242.675C420.867 244.288 410.271 258.109 410.271 258.109C410.271 258.109 398.523 235.304 393.455 232.079C388.387 228.854 386.775 227.933 375.718 226.09C364.661 224.247 359.132 224.938 359.132 224.938Z",
    fill: "#636363",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M365.813 254.884L366.043 297.5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M394.377 271.93H377.561",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M343.929 271.469H358.441",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M347.615 285.981H357.75",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M373.875 286.211H388.848",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M416.26 255.114C416.26 255.114 421.328 260.873 425.935 261.794",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M405.203 252.12C405.203 252.12 397.832 254.654 395.989 258.109",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M370.42 257.417H390.461",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M356.138 256.496H346.923",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M396.911 275.385L395.298 250.968",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.783 275.846C339.783 275.846 343.238 254.884 343.469 253.962",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M410.271 258.109C410.271 258.109 408.428 262.716 408.428 266.172",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M360.514 219.179C360.514 219.179 355.677 220.792 352.451 224.017C349.226 227.242 350.148 230.467 351.76 233.001C353.373 235.535 365.812 250.969 365.812 250.969C365.812 250.969 381.476 237.148 384.01 233.001C386.544 228.855 388.156 226.09 384.24 221.253C380.325 216.415 360.514 219.179 360.514 219.179Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M359.823 221.943L360.744 230.466C360.744 230.466 364.66 239.68 366.042 238.759C367.424 237.837 373.183 230.696 374.105 228.623C375.026 226.55 376.408 217.566 376.408 217.566L360.513 219.178L359.823 221.943Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M389.619 172.886C389.619 172.886 393.097 163.757 410.051 166.583C427.005 169.409 422.223 196.796 418.093 201.36C413.963 205.924 421.788 207.881 423.744 205.055C423.744 205.055 423.961 210.706 415.702 213.532C407.442 216.358 398.965 215.271 394.836 203.534C390.706 191.796 389.619 172.886 389.619 172.886Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M350.929 183.537C350.929 183.537 350.06 196.579 349.19 201.143C348.321 205.708 347.234 212.011 354.624 218.749C362.014 225.487 377.664 226.574 384.837 212.446C384.837 212.446 389.619 214.185 393.531 209.403C397.443 204.621 397.226 199.404 394.618 193.753C392.01 188.102 381.142 182.668 364.188 178.538C347.234 174.408 350.929 183.537 350.929 183.537Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 169.191C376.143 169.191 364.406 163.974 355.494 167.887C346.582 171.8 345.93 184.624 345.93 184.624L358.972 187.45L362.232 182.016L361.58 187.667L374.839 191.579L376.795 186.797L377.012 192.231L382.663 195.057C382.663 195.057 381.576 196.578 382.011 199.404C382.446 202.23 385.054 203.316 385.054 203.316C385.054 203.316 386.576 198.752 391.14 200.056C395.704 201.36 392.661 210.055 390.923 211.576C389.184 213.097 384.837 212.445 384.837 212.445C384.837 212.445 389.184 214.401 391.575 213.314C393.966 212.227 401.139 205.706 401.356 193.1C401.573 180.493 394.835 174.407 387.662 171.147C380.49 167.887 376.143 169.191 376.143 169.191Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M358.754 203.751C358.754 203.751 359.406 206.359 362.014 206.142C364.622 205.925 365.274 204.838 365.274 204.838",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M358.972 210.272C358.972 210.272 363.102 212.88 369.84 209.403",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M369.188 207.446C369.188 207.446 370.058 210.706 372.014 211.358",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M354.407 197.448C354.407 197.448 357.015 196.144 358.972 198.1",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M368.535 200.056C368.535 200.056 372.447 198.969 373.969 201.36",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M360.493 193.318C360.493 193.318 357.885 189.84 353.32 193.318",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M368.535 194.839C368.535 194.839 374.838 192.448 376.795 198.752",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M429.621 238.298C429.621 238.298 430.773 234.382 431.694 231.387C432.615 228.392 435.38 227.471 437.683 224.937C439.986 222.403 440.447 216.414 442.52 218.487C444.593 220.56 442.059 224.937 442.059 224.937L451.273 224.246C451.273 224.246 459.336 217.335 460.027 220.33C460.718 223.325 453.807 231.848 451.504 233.691C449.2 235.534 438.374 238.989 438.374 238.989L436.762 241.523L429.621 238.298Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M435.841 235.073C435.841 235.073 438.836 230.696 441.6 230.466C444.364 230.236 451.736 230.005 451.736 230.005C451.736 230.005 452.427 219.178 454.5 219.639C456.573 220.1 455.191 228.853 454.039 231.387C452.887 233.921 438.375 238.989 438.375 238.989",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M435.841 235.073C435.841 235.073 438.836 230.696 441.6 230.466C444.364 230.236 451.736 230.005 451.736 230.005C451.736 230.005 452.427 219.178 454.5 219.639C456.573 220.1 455.191 228.853 454.039 231.387C452.887 233.921 438.375 238.989 438.375 238.989",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M338.631 266.632C338.631 266.632 330.799 258.8 328.495 255.805C326.191 252.81 316.517 251.889 314.904 256.035C313.292 260.181 315.825 269.856 319.742 275.615C323.658 281.374 329.417 284.138 333.794 282.526C338.171 280.914 340.244 274.924 340.705 272.621",
    fill: "#636363"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M338.631 266.632C338.631 266.632 330.799 258.8 328.495 255.805C326.191 252.81 316.517 251.889 314.904 256.035C313.292 260.181 315.825 269.856 319.742 275.615C323.658 281.374 329.417 284.138 333.794 282.526C338.171 280.914 340.244 274.924 340.705 272.621",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M317.899 253.502C317.899 253.502 315.365 253.041 314.444 257.648C313.523 262.255 316.287 265.941 320.433 266.632C324.579 267.323 329.647 263.177 330.108 260.643C330.569 258.109 329.878 256.497 326.883 253.963C323.888 251.429 319.742 252.12 317.899 253.502Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M324.118 232.309C324.118 232.309 322.736 223.095 327.343 221.943C331.95 220.791 334.714 222.634 334.714 222.634C334.714 222.634 331.719 226.32 332.871 228.163C334.023 230.006 336.326 227.702 336.326 227.702C336.326 227.702 337.017 230.236 338.399 230.927C339.781 231.618 341.624 228.623 341.624 228.623C341.624 228.623 343.006 230.005 343.697 228.162C344.388 226.319 344.388 226.319 344.388 226.319C344.388 226.319 347.613 229.083 346.001 235.073C344.388 241.062 340.012 243.826 340.012 243.826C340.012 243.826 341.624 251.888 340.012 253.962C338.399 256.035 321.353 251.889 319.971 248.664C318.589 245.439 325.96 235.534 325.96 235.534L324.118 232.309Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M322.506 232.079C322.506 232.079 321.124 222.865 325.731 221.713C330.338 220.561 333.102 222.404 333.102 222.404C333.102 222.404 330.107 226.09 331.259 227.933C332.411 229.776 334.714 227.472 334.714 227.472C334.714 227.472 335.405 230.006 336.787 230.697C338.169 231.388 340.012 228.394 340.012 228.394C340.012 228.394 341.394 229.776 342.085 227.933C342.776 226.09 342.776 226.09 342.776 226.09C342.776 226.09 346.001 228.854 344.388 234.843C342.776 240.832 338.399 243.597 338.399 243.597C338.399 243.597 340.012 251.66 338.399 253.733C336.787 255.806 319.74 251.66 318.358 248.435C316.976 245.21 324.347 235.305 324.347 235.305L322.506 232.079Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M317.899 258.339C317.899 258.339 314.674 247.052 313.522 243.135C312.37 239.219 313.983 235.073 317.899 233.23C321.815 231.387 325.04 230.235 324.579 232.309C324.118 234.382 320.202 235.304 319.05 236.225C317.898 237.146 316.977 238.298 316.977 238.298C316.977 238.298 321.584 235.764 324.348 235.303C327.112 234.842 328.264 237.376 325.96 238.758C323.656 240.14 321.583 240.601 320.201 241.983C318.819 243.365 318.358 244.747 318.358 244.747C318.358 244.747 322.504 242.213 325.499 241.752C328.494 241.291 329.415 241.752 328.033 243.365C326.651 244.978 323.656 246.129 322.504 246.82C321.352 247.511 320.661 249.354 320.661 249.354C320.661 249.354 329.415 244.747 328.723 247.051C328.032 249.354 323.886 251.428 323.886 251.428C323.886 251.428 326.65 253.962 324.807 257.648C322.966 261.334 319.281 260.643 317.899 258.339Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M358.714 325.027C358.714 325.027 360.907 307.486 353.389 301.847C348.446 298.14 334.595 296.209 331.776 311.871C328.957 327.533 338.667 377.651 338.354 382.35C338.041 387.049 338.667 392.06 337.414 395.506C336.161 398.952 333.968 402.397 329.583 405.53C325.198 408.662 325.824 411.168 332.715 412.734C339.606 414.3 359.967 412.734 359.967 412.734C359.967 412.734 362.786 410.228 361.533 403.963C360.28 397.698 360.28 387.988 359.967 384.229C359.654 380.47 358.714 325.027 358.714 325.027Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M332.715 412.734C339.606 414.3 359.967 412.734 359.967 412.734C359.967 412.734 362.786 410.228 361.533 403.963C360.825 400.425 360.518 395.79 360.327 391.747H355.581C355.581 391.747 353.702 379.844 346.81 381.41C340.955 382.741 338.724 389.029 338.184 390.895C338.099 392.593 337.899 394.169 337.413 395.506C336.16 398.952 333.967 402.397 329.582 405.53C325.198 408.662 325.824 411.168 332.715 412.734Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M342.739 409.601C334.65 409.601 329.969 408.467 327.445 407.499C325.791 409.716 327.339 411.511 332.715 412.733C339.606 414.299 359.967 412.733 359.967 412.733C359.967 412.733 361.442 411.407 361.78 408.297C358.182 408.85 351.656 409.601 342.739 409.601Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M353.389 301.848C348.447 298.141 334.595 296.21 331.776 311.872C329.588 324.03 334.949 356.947 337.311 373.267H359.637C359.241 356.062 358.715 325.028 358.715 325.028C358.715 325.028 360.907 307.486 353.389 301.848Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M388.813 323.372C388.813 323.372 388.619 305.695 380.409 301.123C375.012 298.117 361.026 298.072 360.346 313.971C359.666 329.87 376.05 378.22 376.373 382.918C376.697 387.616 377.994 392.497 377.217 396.08C376.44 399.663 374.733 403.373 370.81 407.069C366.887 410.764 367.846 413.163 374.886 413.785C381.925 414.407 401.889 410.108 401.889 410.108C401.889 410.108 404.344 407.245 402.257 401.206C400.17 395.168 398.86 385.546 398.043 381.864C397.225 378.182 388.813 323.372 388.813 323.372Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M374.887 413.785C381.927 414.407 401.89 410.108 401.89 410.108C401.89 410.108 404.345 407.245 402.258 401.206C401.08 397.796 400.149 393.244 399.415 389.264L394.713 389.904C394.713 389.904 391.245 378.363 384.628 380.845C379.006 382.954 377.644 389.485 377.361 391.407C377.506 393.101 377.52 394.69 377.219 396.08C376.442 399.663 374.735 403.373 370.812 407.069C366.888 410.764 367.847 413.163 374.887 413.785Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M384.396 409.329C376.381 410.42 371.59 409.928 368.959 409.31C367.619 411.73 369.396 413.3 374.887 413.785C381.927 414.407 401.89 410.108 401.89 410.108C401.89 410.108 403.173 408.595 403.088 405.467C399.596 406.501 393.231 408.126 384.396 409.329Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M380.409 301.123C375.012 298.117 361.026 298.072 360.346 313.971C359.818 326.313 369.571 358.205 374.114 374.058L396.236 371.045C393.522 354.051 388.813 323.372 388.813 323.372C388.813 323.372 388.619 305.696 380.409 301.123Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M462.068 327.497H418.533C417.409 327.497 416.498 326.586 416.498 325.462V293.79C416.498 292.666 417.409 291.755 418.533 291.755H462.068C463.192 291.755 464.103 292.666 464.103 293.79V325.462C464.102 326.586 463.191 327.497 462.068 327.497Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M459.531 327.497H415.996C414.872 327.497 413.961 326.586 413.961 325.462V293.79C413.961 292.666 414.872 291.755 415.996 291.755H459.531C460.655 291.755 461.566 292.666 461.566 293.79V325.462C461.566 326.586 460.655 327.497 459.531 327.497Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M421.761 296.466C420.655 296.466 419.758 297.363 419.758 298.469V327.497H459.562C460.668 327.497 461.565 326.6 461.565 325.494V296.466H421.761Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M462.068 327.497H406.195C405.071 327.497 404.16 326.586 404.16 325.462V318.164C404.16 317.04 405.071 316.129 406.195 316.129H462.068C463.192 316.129 464.103 317.04 464.103 318.164V325.462C464.102 326.586 463.191 327.497 462.068 327.497Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M455.137 327.497H406.195C405.071 327.497 404.16 326.586 404.16 325.462V318.164C404.16 317.04 405.071 316.129 406.195 316.129H455.137C456.261 316.129 457.172 317.04 457.172 318.164V325.462C457.172 326.586 456.261 327.497 455.137 327.497Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M261.138 185.385C261.138 185.385 264.11 181.752 268.898 183.734",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M220.795 297.5C220.795 297.5 217.34 299.343 217.109 310.861C216.879 322.379 221.486 325.604 223.559 326.064C225.632 326.525 277.923 326.064 277.923 326.064C277.923 326.064 284.834 317.08 282.3 308.787C279.766 300.494 278.476 298.49 278.476 298.49L220.795 297.5Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M225.473 226.829C225.473 226.829 219.529 230.627 217.052 235.91C214.575 241.194 198.131 268.904 198.296 272.701C198.461 276.499 222.005 269.098 222.005 269.098C222.005 269.098 219.033 293.37 219.363 295.517C219.693 297.664 221.344 298.984 224.647 298.489C227.949 297.994 278.475 298.489 278.475 298.489C278.475 298.489 281.282 296.177 281.117 291.884C280.952 287.591 274.678 258.53 274.678 258.53L285.741 274.216C285.741 274.216 290.199 276.363 293.171 274.381C296.143 272.4 298.455 263.814 296.804 257.869C295.153 251.925 290.199 250.439 281.448 236.734C272.697 223.029 261.469 221.874 261.469 221.874C261.469 221.874 253.874 218.737 239.674 220.388C225.473 222.041 225.473 226.829 225.473 226.829Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M222.336 263.155L225.143 243.837",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M274.678 258.532L273.357 253.909L272.861 240.864",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M238.517 213.29C238.517 213.29 233.233 215.767 231.747 217.583C230.261 219.399 225.473 220.06 223.656 223.362C221.84 226.664 223.161 229.306 223.161 229.306C223.161 229.306 232.903 232.939 244.956 237.562C257.009 242.185 260.807 239.378 263.614 235.581C266.421 231.783 269.558 227.49 269.888 224.353C270.218 221.216 268.237 218.739 262.788 215.767C257.34 212.794 244.957 210.813 238.517 213.29Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 175.643C270.715 175.643 274.347 179.276 272.861 183.403C271.375 187.531 272.531 191.989 274.017 192.484C275.503 192.979 279.466 192.319 278.31 196.282C277.154 200.245 274.347 201.566 274.347 201.566C274.347 201.566 272.696 210.152 270.88 213.454C269.064 216.756 264.44 215.766 262.789 215.766C261.138 215.766 260.147 215.931 260.147 215.931L255.854 238.717C255.854 238.717 255.193 241.689 246.112 230.296C237.031 218.903 238.517 216.922 238.517 216.922L233.564 192.98C233.564 192.98 226.299 179.44 242.15 171.515C258.001 163.59 270.715 175.643 270.715 175.643Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M257.01 177.955C257.01 177.955 260.857 182.786 256.399 184.933C251.941 187.08 248.686 189.218 248.686 189.218L249.543 194.531L245.258 192.303C245.258 192.303 246.305 196.435 246.8 196.93C247.295 197.425 245.258 200.186 245.258 200.186L236.369 198.594L237.545 210.469L229.764 196.282C229.764 196.282 224.15 193.475 222.169 184.229C220.188 174.983 231.25 162.764 243.304 160.122C255.357 157.48 261.137 158.966 268.897 162.599C276.657 166.232 279.63 173.662 279.63 173.662L275.997 171.516C275.997 171.516 278.474 177.46 278.309 178.451C278.144 179.442 268.567 177.13 268.567 177.13L270.879 181.258C270.879 181.258 263.12 177.955 257.01 177.955Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M245.602 201.386C245.602 201.386 241.316 194.481 237.683 193.325C234.05 192.169 232.73 199.269 236.197 203.397C239.664 207.525 244.916 205.841 244.916 205.841",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M245.602 201.386C245.602 201.386 241.316 194.481 237.683 193.325C234.05 192.169 232.73 199.269 236.197 203.397C239.664 207.525 244.916 205.841 244.916 205.841",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M265.926 190.421C265.926 191.652 265.372 192.65 264.688 192.65C264.004 192.65 263.45 191.652 263.45 190.421C263.45 189.19 264.005 188.192 264.688 188.192C265.372 188.192 265.926 189.19 265.926 190.421Z",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M262.789 201.402C262.789 201.402 264.44 205.2 270.88 204.044",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M260.147 215.932C260.147 215.932 250.24 213.29 247.268 209.823C247.268 209.823 247.598 212.135 251.396 218.409C255.194 224.683 258.001 227.325 258.001 227.325L260.147 215.932Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M224.962 260.479C223.034 259.246 220.639 258.994 218.497 259.798C213.237 261.773 203.509 265.413 201.366 266.127C198.394 267.118 196.412 271.08 196.578 275.869C196.743 280.657 199.055 284.29 205.164 283.629C211.273 282.968 221.544 277.887 224.516 275.799C227.488 273.71 228.281 270.75 228.281 270.75L228.116 262.494L224.962 260.479Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M228.115 262.495C228.115 262.495 235.71 262.66 238.848 262.66C241.986 262.66 248.095 269.43 248.095 269.925C248.095 270.42 246.609 270.751 246.609 270.751H228.28L228.115 262.495Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M233.117 262.591C230.481 262.545 228.115 262.494 228.115 262.494L228.28 270.75H233.3L233.117 262.591Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M271.926 301.455H228.39C227.266 301.455 226.355 300.544 226.355 299.42V272.513C226.355 271.389 227.266 270.478 228.39 270.478H271.925C273.049 270.478 273.96 271.389 273.96 272.513V299.42C273.96 300.544 273.049 301.455 271.926 301.455Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M294.335 221.769C294.335 221.769 294.764 219.586 291.065 217.182C287.366 214.778 283.113 216.442 281.633 217.367C280.154 218.292 280.154 218.292 280.154 218.292C280.154 218.292 283.298 220.326 283.298 222.73C283.298 225.134 282.003 227.354 279.414 227.723C276.825 228.093 276.825 228.093 276.825 228.093C276.825 228.093 277.195 232.532 282.188 234.196C287.181 235.861 292.175 233.826 294.764 230.127C297.353 226.429 294.335 221.769 294.335 221.769Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M284.207 249.199C284.207 249.199 281.004 240.024 281.873 238.205C282.742 236.386 287.628 235.572 287.628 235.572C287.628 235.572 283.339 230.93 285.375 230.089C287.411 229.248 291.048 235.002 291.048 235.002C291.048 235.002 287.791 228.514 288.279 226.424C288.768 224.334 290.804 225.501 291.319 226.587C291.835 227.673 294.169 233.645 294.169 233.645C294.169 233.645 293.165 228.623 292.893 226.994C292.622 225.365 291.21 221.918 292.622 221.348C294.034 220.778 294.495 222.542 294.495 222.542C294.495 222.542 295.689 220.669 297.155 222.433C298.621 224.197 299.951 232.178 299.462 234.268C298.973 236.358 287.545 243.117 287.545 243.117L290.504 247.813L284.207 249.199Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M294.496 222.542C294.496 222.542 297.699 229.708 297.753 233.047L294.496 222.542Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M294.496 222.542C294.496 222.542 297.699 229.708 297.753 233.047",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M291.85 243.176L280.622 246.148L281.448 250.276L292.345 247.634L291.85 243.176Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M281.448 250.276C281.448 250.276 279.797 250.771 279.797 253.578C279.797 256.385 282.109 269.925 282.934 272.897C283.759 275.869 284.915 278.841 291.52 278.511C298.125 278.181 300.766 275.704 300.766 272.072C300.766 268.44 295.813 250.772 295.317 248.625C294.822 246.479 292.345 247.634 292.345 247.634L281.448 250.276Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M248.898 373.747C248.898 373.747 250.971 327.215 249.128 314.546C248.591 310.856 247.018 308.142 245.059 306.15C236.672 297.624 222.32 302.724 220.618 314.562C220.465 315.625 220.367 316.769 220.333 318.001C219.872 334.817 225.862 375.82 225.862 375.82C225.862 375.82 222.637 378.354 224.019 380.888C225.401 383.422 225.401 384.804 225.401 384.804C225.401 384.804 223.328 387.338 223.789 388.72C224.25 390.102 224.71 392.406 224.71 392.406L225.401 394.018C225.401 394.018 226.092 398.164 222.867 403.002C219.642 407.839 217.338 409.222 217.799 412.677C218.26 416.132 233.463 416.823 239.452 415.672C245.441 414.52 248.897 414.06 250.279 411.756C251.661 409.453 250.279 391.024 250.279 391.024C250.279 391.024 251.431 387.799 251.431 386.187C251.431 384.575 250.51 383.653 250.74 382.962C250.97 382.271 252.583 382.732 253.044 379.737C253.505 376.742 248.898 373.747 248.898 373.747Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M251.432 386.186C251.432 384.574 250.511 383.652 250.741 382.961C250.971 382.27 252.584 382.731 253.045 379.736C253.506 376.741 248.899 373.747 248.899 373.747C248.899 373.747 250.972 327.215 249.129 314.546C248.592 310.856 247.02 308.142 245.06 306.15C236.673 297.624 222.321 302.724 220.619 314.562C220.466 315.625 220.368 316.769 220.334 318.001C219.873 334.817 225.863 375.82 225.863 375.82C225.863 375.82 222.638 378.354 224.02 380.888C225.402 383.422 225.402 384.804 225.402 384.804C225.402 384.804 223.329 387.338 223.789 388.72C224.25 390.102 224.71 392.406 224.71 392.406L225.401 394.019C225.401 394.019 224.019 387.799 230.699 385.956C237.379 384.113 241.986 388.26 242.678 391.485C243.369 394.71 245.903 392.406 250.28 391.024C250.28 391.024 251.432 387.799 251.432 386.186Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M250.28 411.755C250.523 411.351 250.679 410.442 250.773 409.23C247.589 410.616 242.235 412.638 236.689 413.368C229.991 414.249 221.41 412.704 217.747 411.929C217.751 412.169 217.765 412.416 217.8 412.677C218.261 416.132 233.464 416.823 239.453 415.672C245.443 414.519 248.898 414.059 250.28 411.755Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M249.359 381.348C249.359 381.348 225.172 378.123 229.088 379.275C233.004 380.427 241.988 382.27 241.988 382.27",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 373.747C257.164 373.747 255.091 327.215 256.934 314.546C257.471 310.856 259.044 308.142 261.003 306.15C269.39 297.624 283.742 302.724 285.444 314.562C285.597 315.625 285.695 316.769 285.729 318.001C286.19 334.817 280.2 375.82 280.2 375.82C280.2 375.82 283.425 378.354 282.043 380.888C280.661 383.422 280.661 384.804 280.661 384.804C280.661 384.804 282.734 387.338 282.273 388.72C281.812 390.102 281.352 392.406 281.352 392.406L280.661 394.018C280.661 394.018 279.97 398.164 283.195 403.002C286.42 407.839 288.724 409.222 288.263 412.677C287.802 416.132 272.599 416.823 266.61 415.672C260.621 414.52 257.165 414.06 255.783 411.756C254.401 409.453 255.783 391.024 255.783 391.024C255.783 391.024 254.631 387.799 254.631 386.187C254.631 384.575 255.552 383.653 255.322 382.962C255.092 382.271 253.479 382.732 253.018 379.737C252.557 376.742 257.164 373.747 257.164 373.747Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M254.631 386.186C254.631 384.574 255.552 383.652 255.322 382.961C255.092 382.27 253.479 382.731 253.019 379.736C252.559 376.741 257.165 373.747 257.165 373.747C257.165 373.747 255.092 327.215 256.935 314.546C257.472 310.856 259.044 308.142 261.004 306.15C269.391 297.624 283.743 302.724 285.445 314.562C285.598 315.625 285.696 316.769 285.73 318.001C286.191 334.817 280.201 375.82 280.201 375.82C280.201 375.82 283.426 378.354 282.044 380.888C280.662 383.422 280.662 384.804 280.662 384.804C280.662 384.804 282.735 387.338 282.274 388.72C281.813 390.102 281.353 392.406 281.353 392.406L280.662 394.019C280.662 394.019 282.044 387.799 275.364 385.956C268.684 384.113 264.077 388.26 263.385 391.485C262.694 394.71 260.16 392.406 255.783 391.024C255.783 391.024 254.631 387.799 254.631 386.186Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M255.782 411.755C255.539 411.351 255.383 410.442 255.289 409.23C258.473 410.616 263.827 412.638 269.373 413.368C276.071 414.249 284.652 412.704 288.315 411.929C288.311 412.169 288.297 412.416 288.262 412.677C287.801 416.132 272.598 416.823 266.609 415.672C260.62 414.519 257.164 414.059 255.782 411.755Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M256.704 381.348C256.704 381.348 280.891 378.123 276.975 379.275C273.059 380.427 264.075 382.27 264.075 382.27",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M495.141 364.808C495.141 364.808 497.647 365.434 497.334 376.085C497.021 386.735 484.491 403.963 481.672 406.469C478.853 408.975 461.625 409.915 461.625 409.915L463.818 403.024C463.818 403.024 475.408 403.964 478.853 401.458C482.299 398.952 490.443 378.905 490.756 373.267C491.069 367.629 488.563 361.677 488.563 361.677L495.141 364.808Z",
    fill: "#636363",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M460.998 356.351C460.998 356.351 484.178 354.158 487.936 356.664C491.695 359.17 495.14 364.808 495.14 364.808C495.14 364.808 479.478 364.495 473.527 365.121C467.576 365.747 464.443 366.061 464.443 366.061L460.998 356.351Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M494.201 416.493C494.201 416.493 492.008 418.372 485.744 417.119C479.479 415.866 468.516 411.167 464.444 412.107C460.372 413.047 456.613 413.673 456.613 413.673L468.829 405.842C468.829 405.842 476.347 406.155 482.298 409.601C488.249 413.047 495.141 411.48 495.141 411.48L494.201 416.493Z",
    fill: "#636363",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M472.588 367.941C472.588 367.941 492.635 397.072 498.587 403.024C504.539 408.976 502.972 409.602 499.84 412.734C496.708 415.866 492.322 419.938 490.443 416.18C488.564 412.421 492.009 408.349 486.684 401.458C481.359 394.567 469.143 384.543 469.143 384.543L472.588 367.941Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M465.07 357.291C465.07 357.291 449.721 349.773 443.77 346.641C437.819 343.509 430.301 343.822 424.349 349.147C418.397 354.472 414.639 374.519 414.639 374.519C414.639 374.519 403.676 385.482 399.604 389.554C395.532 393.626 393.652 400.517 397.098 404.276C400.544 408.035 420.278 422.13 432.494 423.697C444.71 425.263 463.505 419.312 467.89 415.553C472.275 411.794 472.589 410.228 472.275 394.879C471.962 379.53 476.034 372.326 473.528 365.121C471.021 357.917 465.07 357.291 465.07 357.291Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M462.251 362.302C456.613 365.748 455.047 373.892 454.107 390.807C454.107 390.807 452.227 408.035 447.842 411.481C443.457 414.927 429.361 418.059 430.927 420.878C431.609 422.106 433.481 423.155 436.332 423.948C448.322 424.093 463.942 418.936 467.89 415.553C472.275 411.794 472.589 410.228 472.275 394.879C471.962 379.53 476.034 372.326 473.528 365.121C472.88 363.259 472.001 361.843 471.056 360.757C467.556 360.688 464.252 361.08 462.251 362.302Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M465.07 357.291C465.07 357.291 449.721 349.773 443.77 346.641C437.818 343.509 430.301 343.822 424.349 349.147C418.397 354.472 414.639 374.519 414.639 374.519C414.326 376.398 414.013 381.097 430.301 390.807C446.589 400.517 447.842 400.831 451.601 397.385C455.36 393.939 455.673 387.361 456.3 373.266C456.927 359.171 470.709 361.363 470.709 361.363L471.312 361.07C468.552 357.669 465.07 357.291 465.07 357.291Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M428.421 350.713C423.722 355.725 418.397 374.832 418.397 374.832C418.397 374.832 421.216 382.036 434.372 387.362C447.528 392.687 449.094 393.94 450.347 387.988C451.6 382.036 449.094 367.314 455.359 361.676C458.249 359.075 461.532 357.683 464.329 356.928C461.204 355.394 448.941 349.363 443.769 346.641C443.769 346.641 433.12 345.701 428.421 350.713Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M447.215 382.193C447.215 384.355 445.602 386.108 443.613 386.108C441.623 386.108 440.011 384.355 440.011 382.193C440.011 380.03 441.624 378.277 443.613 378.277C445.602 378.278 447.215 380.031 447.215 382.193Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M430.144 372.483C430.144 374.646 428.531 376.398 426.542 376.398C424.552 376.398 422.94 374.645 422.94 372.483C422.94 370.321 424.553 368.568 426.542 368.568C428.531 368.567 430.144 370.32 430.144 372.483Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M409.314 381.723C409.314 381.723 409.314 382.036 424.036 392.373C438.758 402.71 445.023 403.65 445.023 403.65C445.023 403.65 439.698 404.903 435.313 408.035C430.928 411.167 430.614 413.36 430.614 413.36L400.856 393C400.856 393 400.23 388.615 409.314 381.723Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M122.124 290.571C122.124 290.571 118.052 305.606 115.233 311.871C112.414 318.136 104.583 324.087 106.149 325.967C107.715 327.846 117.112 327.533 118.365 327.22C119.618 326.907 128.389 313.437 128.389 313.437L122.124 290.571Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M184.459 282.74C184.459 282.74 175.375 270.837 168.484 263.633C161.593 256.429 134.028 266.139 124.944 270.211C115.86 274.283 120.245 294.957 121.185 302.474C122.125 309.992 120.245 324.714 123.064 326.28C125.883 327.846 187.278 327.846 191.976 326.593C196.675 325.34 201.06 323.461 197.614 313.75C194.168 304.04 187.277 292.137 186.651 290.257C186.025 288.378 184.459 282.74 184.459 282.74Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M160.652 274.283C160.652 274.283 138.725 278.668 133.4 280.861C128.075 283.054 127.135 284.933 129.328 292.764C131.521 300.595 132.147 325.654 134.966 326.28C137.785 326.906 141.544 326.906 141.544 326.906L191.975 326.593C191.975 326.593 199.806 330.039 199.179 319.075C198.553 308.112 191.661 297.462 184.144 287.125C176.628 276.789 173.809 269.897 160.652 274.283Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M176.314 284.306C176.314 284.306 140.605 294.016 138.725 294.33C136.846 294.643 136.846 294.643 136.846 294.643L138.412 302.787L179.133 291.511L176.314 284.306Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M124.317 307.173L129.016 308.113C129.016 308.113 125.57 293.704 125.57 286.186C125.57 278.668 128.702 276.789 133.714 275.223C138.726 273.657 157.833 268.332 164.725 268.332C171.616 268.332 176.315 272.717 176.315 272.717C176.315 272.717 170.99 264.573 168.484 263.633C165.978 262.693 144.365 266.765 135.281 270.524C126.197 274.283 122.438 275.536 122.125 279.608C121.811 283.68 124.317 307.173 124.317 307.173Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M180.639 416.174C196.804 412.357 206.814 396.158 202.997 379.992C199.18 363.827 182.981 353.817 166.816 357.634C150.651 361.451 140.64 377.65 144.457 393.815C148.274 409.981 164.473 419.991 180.639 416.174Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M184.946 401.576C181.477 400.31 177.687 399.614 173.718 399.614C165.413 399.614 157.894 402.664 152.451 407.596",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M195.222 407.813C193.186 405.926 190.849 404.306 188.283 403.017",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M161.128 388.209C164.958 389.811 169.223 390.705 173.719 390.705C185.77 390.705 196.166 384.283 200.965 375.009",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M147.874 377.399C150.2 380.93 153.382 383.944 157.16 386.206",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M144.546 390.827C152.708 394.04 162.798 395.939 173.719 395.939C183.906 395.939 193.371 394.287 201.221 391.457",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector3.cd38c1d51fc21b0f7c594a05d9670721.svg";
export { ForwardRef as ReactComponent };